
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"5.506","height":"8.806"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"id":"Path_1049","data-name":"Path 1049","d":"M-163.646 223.429l-.509-1.868a.824.824 0 00-.657-.594 1.037 1.037 0 00-.232-.012l-.213-2.128h.549a.272.272 0 00.274-.272.273.273 0 00-.273-.273h-3.355a.274.274 0 00-.274.272.274.274 0 00.273.273h.55l-.213 2.128h-.1a.831.831 0 00-.232.033.829.829 0 00-.565.573l-.509 1.868a.274.274 0 00.142.316 4.705 4.705 0 002.068.607v1.82l.533.915.552-.915v-1.814a4.622 4.622 0 002.047-.607.272.272 0 00.144-.322z","transform":"translate(169.141 -218.28)","fill":"#6b7786"}})])
          )
        }
      }
    